import React from 'react';
import './MyErrorDisplay.less';

const DEFAULT_ERR_MSG = 'An error occured. Please try again later';
const DEFAULT_RETRY_BTN_TEXT = 'Retry';

const ErrorDisplay = (props: any): React.ReactElement => {
  const {
    message = DEFAULT_ERR_MSG,
    btnText = DEFAULT_RETRY_BTN_TEXT,
    bridge,
  } = props;

  const handleRetry = () => {
    if (!bridge) return;
    const player = bridge.player();
    player.trigger('on-retry');
  };

  return (
    <div className="vjs-modal-dialog-content">
      <div className="intelligence-error-display-content">
        <p className="intelligence-error-tips">{message}</p>
        <button className="intelligence-retry-btn" onClick={handleRetry}>
          {btnText}
        </button>
      </div>
    </div>
  );
};

export default ErrorDisplay;
